import type { InboxItem } from '../../types/inbox';

export type InboxContentFilter = 'all' | 'email' | 'call' | 'sms' | 'task';

/**
 * Rows visible for the active filters. Shared by the list and the header
 * count so the "Inbox (n)" heading always matches what's on screen.
 */
export const filterInboxItems = (
  items: InboxItem[],
  contentFilter: InboxContentFilter,
  assigneeFilter: string | null,
): InboxItem[] => {
  let filtered = items;

  if (contentFilter !== 'all') {
    filtered = filtered.filter(item => item.channel === contentFilter);
  }

  if (assigneeFilter) {
    filtered = filtered.filter(
      item => item.assigned_to?.toString() === assigneeFilter
    );
  }

  return filtered;
};
